import styled from 'styled-components'
import { Text, SecondaryView as StormSecondaryView } from '@amzn/storm-ui'

export const AdvertisingLogoContainer = styled.img`
  margin-top: 14px;
  height: 18px;
`

export const Headline = styled(Text)<{ hasLogo: boolean }>`
  margin: ${({ hasLogo }) => (hasLogo ? `6px` : `18px`)} 0 18px 0;
  text-align: center;
  justify-self: center;
  color: ${({ theme }) => theme.palette.white};
`

export const SecondaryView = styled(StormSecondaryView)`
/* Fall back to auiblue background if linear-gradient isn't supported by the browser */
background: ${({ theme }) => theme.palette.auiblue}};
background: linear-gradient(45deg, #0e5a65, #008787, #38b293);
`

export const CarouselSlideContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`

export const HeaderWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.inkwell}};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
